module.exports = __webpack_public_path__ + "assets/svg/UI/groups-white-78d378.svg";